import { render, staticRenderFns } from "./AddVehicleModal.vue?vue&type=template&id=0b3e2d98"
import script from "./AddVehicleModal.vue?vue&type=script&lang=js"
export * from "./AddVehicleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports